var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#copy-link_svg__clip0_2607_2515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.334 10.833a4.165 4.165 0 006.283.45l2.5-2.5a4.167 4.167 0 00-5.892-5.891L9.792 4.317m1.875 4.85a4.165 4.165 0 00-6.284-.45l-2.5 2.5a4.167 4.167 0 005.892 5.891l1.425-1.425",
    stroke: "#7A89F4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "copy-link_svg__clip0_2607_2515"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}
export default SvgCopyLink;